import React from 'react';
import { NavigationSection } from './NavigationSection';
import { NavigationSectionLink } from './NavigationSectionLink';
import { NavigationLink } from './NavigationLink';
import { NavigationProvider, type NavigationProviderProps } from './NavigationContext';

export function Navigation(props: NavigationProviderProps) {
	return (
		<NavigationProvider {...props}>
			<nav className="flex-1 overflow-y-auto overflow-x-hidden">{props.children}</nav>
		</NavigationProvider>
	);
}

Navigation.NavigationLink = NavigationLink;
Navigation.NavigationSection = NavigationSection;
Navigation.NavigationSectionLink = NavigationSectionLink;
